import LogosCarousel from '../plugins/PluginLogosCarousel.ts'; // if you want to use on a project

window.addEventListener('load', () => {


    new LogosCarousel('[data-logos]', {
        rootMargin: "0px",
        root: null,
        threshold: 0,
        duration: 8,
        imageWidth: 'auto',
        imageHeight: 'auto',
        imageGap: 65,
        stopOnHover: true,
        useIntersectionObserver: true
    });
});